var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClipboardCopy',{attrs:{"value":_vm.name}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"gray"}},[_c('ClipboardCopy',{attrs:{"value":_vm.idFormatted}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }